import { ctApi } from '@/api';
import { BYOB_PRODUCT_KEY } from '@/lib/customizers/boxes';
import { getListPrice } from '@/lib/product/prices';

export async function getBasePrice() {
  const response = await ctApi
    .productProjections()
    .withKey({ key: BYOB_PRODUCT_KEY })
    .get()
    .execute();
  return getListPrice(response.body.masterVariant.prices ?? []).value;
}
